import { TagsManagerController } from '../controller/TagsManagerController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class TagsManagerWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TagsManagerController,
    });
  }
}
